import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { DELIGHTFUL_DRINKS } from "../../../constants/Constants";
require("./booth.scss");

class DessertDelights extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Delightful Drinks</div>
        <Card.Img
          className="booth-image"
          src="https://nbcf.s3-us-west-1.amazonaws.com/resonate/PRODUCT0396-H-MangoLassi.jpg"
        />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {DELIGHTFUL_DRINKS.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default DessertDelights;
